import React, { Fragment } from 'react';
import Slider from 'react-slick';
import {
    Area, Title, RedStripe, TopText, PackagesHolder, PackageHolder, TopPart,
    TopPartTitle, TopPartText, BottomPart, Insurance, NoWrap, RedBold, InsuranceCTA,
    Arrow, SliderPackagesHolder,
} from './Packages.style';
import { TABLET_WIDTH, ANIMATION_SPEED } from '../globalUtils';

const NextArrow = ({ className, onClick }) => {
    return (
        <Arrow
            className={className}
            onClick={onClick}
            style={{ transform: 'rotate(180deg)', right: '0px' }}
        >></Arrow>
    );
}
const PrevArrow = ({ className, onClick }) => {
    return (
        <Arrow
            className={className}
            onClick={onClick}
            style={{ transform: 'rotate(0deg)', left: '0px' }}
        >{'<'}</Arrow>
    );
}

const getInsurances = (content) => {
    return Object.keys(content)
        .filter(k => k.indexOf('ins') !== -1)
        .map(k => content[k]);
};

const Package = ({ packageContent, i, length, setFormActive }) => {
    const { title, description, cta } = packageContent;
    const insurances = getInsurances(packageContent);
    return <PackageHolder>
        <TopPart last={i === length - 1}>
            <TopPartTitle>{!!title && title.text}</TopPartTitle>
            <TopPartText>{!!description && description.text}</TopPartText>
        </TopPart>
        <BottomPart last={i === length - 1}>
            <Insurance>{insurances.map((ins, idx, { length }) =>
                <Fragment key={`ins-${i}-${idx}`}>
                    <NoWrap>{ins.text}</NoWrap>
                    {idx < length - 1 ?
                        <RedBold>+</RedBold> : ''}
                </Fragment>
            )}</Insurance>
            <InsuranceCTA onClick={() => setFormActive(true)}>{!!cta && cta.text}</InsuranceCTA>
        </BottomPart>
    </PackageHolder>;
};

const getPackages = (content) => {
    return Object.keys(content)
        .filter(k => k.indexOf('package') !== -1)
        .map(k => content[k]);
};

const ResponsivePackages = ({ packages }) => {
    const settings = {
        infinite: true,
        speed: ANIMATION_SPEED,
        slidesToShow: 2,
        slidesToScroll: 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: TABLET_WIDTH,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    };

    return <SliderPackagesHolder>
        <Slider {...settings}>{
            packages
        }</Slider>
    </SliderPackagesHolder>;
};

const Packages = ({ content, setFormActive }) => {
    if (!content) {
        return '';
    }
    const packages = getPackages(content);
    const { segmentTitle, text } = content;
    const renderedPackages = packages.map((p, i, { length }) => <Package
        key={`package-${i}`}
        packageContent={p}
        i={i}
        length={length}
        setFormActive={setFormActive}
    />);
    return <Area>
        <Title>
            <RedStripe />
            {!!segmentTitle && segmentTitle.text}
        </Title>
        <TopText>{!!text && text.text}</TopText>
        <PackagesHolder>{renderedPackages}</PackagesHolder>
        <ResponsivePackages
            packages={renderedPackages}
        />
    </Area>;
};

export default Packages;